import { FC, useState } from 'react'
import { FormControlLabel, Switch } from '@mui/material'

import { ParsedItem } from '../model/ItemParser'
import TypeStats from './TypeStats'
import { sumAsteroidTypes } from '../model/AsteroidStats'

import './AsteroidStats.css'

type AsteroidStatsArguments = {
  items: Array<ParsedItem>
}

const AsteroidStats: FC<AsteroidStatsArguments> = (properties) => {
  const [groupByType, setGroupByType] = useState(false)

  const toggleGroupByType = () => {
    setGroupByType(!groupByType)
  }

  const lastComponent = (itemName: string): string =>
    itemName.substring(itemName.lastIndexOf(' ') + 1, itemName.length)

  let asteroidsToDisplay = properties.items
  if (groupByType) {
    const asteroidsWithReducedNames = properties.items
      .map(item => ({ ...item, name: lastComponent(item.name) }))
    asteroidsToDisplay = sumAsteroidTypes(asteroidsWithReducedNames)
  }

  return (
    <>
      <TypeStats items={ asteroidsToDisplay }>
      </TypeStats>
      <div className="group-by-type-switch">
        <FormControlLabel control={ <Switch value={ groupByType } size="small" onChange={ toggleGroupByType }/> } label="Group by Type"/>
      </div>
    </>
  )
}

export default AsteroidStats
